import {typeCompositionModule} from "../TypeCompositionModule";
import {cornerTypeModule} from "../CornerTypeModule";

export const CompositionTableFilterData = [
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "shortDescription",
        "id": "shortDescription",
    },
    {
        "idFromColumnFilter": "lengthLeft",
        "id": "lengthLeft",
    },
    {
        "idFromColumnFilter": "lengthRight",
        "id": "lengthRight",
    },
    {
        "idFromColumnFilter": "lengthLeftTop",
        "id": "lengthLeftTop",
    },
    {
        "idFromColumnFilter": "lengthRightTop",
        "id": "lengthRightTop",
    },
    {
        "idFromColumnFilter": "lengthLeftTableTop",
        "id": "lengthLeftTableTop",
    },
    {
        "idFromColumnFilter": "lengthRightTableTop",
        "id": "lengthRightTableTop",
    },
    {
        "idFromColumnFilter": "price",
        "id": "price",
    },
    {
        "idFromColumnFilter": "alternativePrice",
        "id": "alternativePrice",
    },
    {
        "idFromColumnFilter": "discountAmount",
        "id": "discountAmount",
    },
    {
        "idFromColumnFilter": "typeComposition",
        "id": "typeComposition",
        "filterFn": (value, filterValue) => typeCompositionModule[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "cornerType",
        "id": "cornerType",
        "filterFn": (value, filterValue) => cornerTypeModule[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]